import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/viewWorkOrder/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/viewWorkOrder/COMMON_REQ_FAIL';

export const LOAD_VIEW_WORK_ORDERS_REQ = 'cris/viewWorkOrder/LOAD_VIEW_WORK_ORDERS_REQ';
export const LOAD_VIEW_WORK_ORDERS_SUCCESS = 'cris/viewWorkOrder/LOAD_VIEW_WORK_ORDERS_SUCCESS';

export const LOAD_FILTERED_WORK_ORDERS_SUCCESS = 'cris/viewWorkOrder/LOAD_FILTERED_WORK_ORDERS_SUCCESS';
export const LOAD_SEARCHED_WORK_ORDERS_SUCCESS = 'cris/viewWorkOrder/LOAD_SEARCHED_WORK_ORDERS_SUCCESS';

const initialState = {
	isLoading: false,
	isSearched: false,
	error: null,
	workOrderList: [],
	customerList: [],
	viewWorkOrders: [],
	searchedWorkOrders: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_VIEW_WORK_ORDERS_REQ:
			return {
				...state,
				isLoading: true,
				isSearched: false,
				viewWorkOrders: []
			};

		case LOAD_VIEW_WORK_ORDERS_SUCCESS:
			const customerList = [];

			action.payload.data.customers.forEach(item => {
				const {users} = item;
				users.forEach(user => {
					customerList.push({
						value: item.id + '_' + user.id,
						label: item.name + ' -- ' + user.email
					});
				});
			});

			const workOrderList = action.payload.data.work_orders.map((item) => ({
				value: item.id,
				label: item.old_code ? item.code + ' -- ' + item.old_code : item.code
			}));

			return {
				...state,
				isLoading: false,
				customerList: customerList,
				workOrderList: workOrderList
			};

		case LOAD_FILTERED_WORK_ORDERS_SUCCESS:
			const viewWorkOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				revision: item.revision,
				prr_ncn: item.prr_ncn || '',
				break_point_info: item.break_point_info || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				work_order_status: item.work_order_status,
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : '',
				partsNumber: item.parts ? item.parts.map(item => item.number).join(', ') : ''
			}));

			return {
				...state,
				isLoading: false,
				isSearched: true,
				viewWorkOrders: viewWorkOrders
			};

		case LOAD_SEARCHED_WORK_ORDERS_SUCCESS:
			const searchedWorkOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				revision: item.revision,
				prr_ncn: item.prr_ncn || '',
				break_point_info: item.break_point_info || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				work_order_status: item.work_order_status,
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : '',
				partsNumber: item.parts ? item.parts.map(item => item.number).join(', ') : ''
			}));

			return {
				...state,
				isLoading: false,
				isSearched: true,
				searchedWorkOrders: searchedWorkOrders
			};

		default:
			return state;
	}
}